import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

import FormikControl from "@Components/FormikControl/FormikControl.js";
import { Button } from "@material-ui/core";
import useStyles from "@Views/Styles/LoginStyles";
import { useAuth } from "views/Authentication/AuthContext";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import FGVLogo from "assets/img/fgv-logo.png";
import { getRedirectUrl } from "utils";
import eightAxios from "configs/axiosConfig";
import { LOGIN_VERIFY_URL, URLS } from "configs/constants";

const LoginPassword = (props) => {
  const [forgotPassword, setForgotPassword] = useState(false);
  const classes = useStyles();

  let initialValues = {
    password: "",
  };

  const {
    login,
    loggedIn,
    authLoading,
    errorMessage,
    logout,
    setErrorMessage,
    passwordChange,
  } = useAuth();

  const onSubmit = (values) => {
    login(
      props.location.state.employee_id,
      values.password,
      values.password,
      false
    );
  };

  const validationSchema = Yup.object({
    password: Yup.string().required("Password Required*"),
  });

  const handleForgotPassword = () => {
    setForgotPassword(true);
  };

  if (loggedIn) {
    let redirectUrl = getRedirectUrl();
    if (redirectUrl)
      return (
        <Redirect to={{ pathname: redirectUrl, state: { login: true } }} />
      );
    setErrorMessage("User doesn't have any module/s assigned.");
    // logout();
  }

  if (passwordChange) {
    return (
      <Redirect
        to={{ pathname: "/password-update", state: { passwordChange: true } }}
      />
    );
  }

  if (forgotPassword) {
    let data = new FormData();
    data.append("employee_id", props.location.state.employee_id);
    data.append("forgotPassword", true);
    eightAxios
      .post(LOGIN_VERIFY_URL, data)
      .then(() => {})
      .catch(() => {});
    return (
      <Redirect
        to={{
          pathname: URLS.LOGIN_OTP,
          state: {
            employee_id: props.location.state.employee_id,
            mobile_number: props.location.state.mobile_number,
            forgotPassword: true,
          },
        }}
      />
    );
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {!authLoading ? (
        (formik) => {
          return (
            <Form style={{ width: "100%" }}>
              <Grid
                className={classes.root}
                container
                spacing={2}
                direction="column"
                alignItems="center"
                justify="center"
              >
                <Grid item xs={10} sm={6} lg={3}>
                  <img src={FGVLogo} alt="FGV" width={200} />
                </Grid>
                <Grid item xs={10} sm={6} lg={3}>
                  <Typography variant="h4">Enter Password</Typography>
                </Grid>

                <Grid className={classes.grid} item xs={10} sm={6} lg={3}>
                  <FormikControl
                    control="input"
                    labelClasses={classes.labelStyles}
                    variant="outlined"
                    label={
                      formik.touched.password && formik.errors.password
                        ? formik.errors.password
                        : "Password"
                    }
                    name="password"
                    password
                    fullWidth
                    size="small"
                  />
                  <Grid item container justify="center">
                    <Button
                      onClick={handleForgotPassword}
                      className={classes.forgetPasswordButton}
                    >
                      Forgot Password?
                    </Button>
                  </Grid>
                  <Grid item>
                    <Typography
                      align="center"
                      variant="subtitle1"
                      color="error"
                    >
                      {errorMessage.length ? errorMessage : errorMessage}
                    </Typography>
                  </Grid>

                  <Button
                    className={classes.loginButton}
                    type="submit"
                    disabled={!formik.isValid || authLoading}
                    variant="contained"
                    color="primary"
                    fullWidth
                  >
                    Login
                  </Button>
                </Grid>
              </Grid>
            </Form>
          );
        }
      ) : (
        <LoadingIcon image text="Logging in" />
      )}
    </Formik>
  );
};
LoginPassword.propTypes = {
  location: PropTypes.object,
};
export default LoginPassword;
